var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:'orders',staticClass:"orders",class:{'orders--scrolled': _vm.scrolled}},[_vm._l((_vm.openOrders),function(order){return _c('order',{key:order.id,attrs:{"order":order,"history":false}})}),_c('div',{staticClass:"orders__more-indicator"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }